/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var XIcon20Solid = forwardRef('XIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M3.44 3.44a1.5 1.5 0 0 1 2.12 0L10 7.878l4.44-4.44a1.5 1.5 0 0 1 2.12 2.122L12.122 10l4.44 4.44a1.5 1.5 0 0 1-2.122 2.12L10 12.122l-4.44 4.44a1.5 1.5 0 0 1-2.12-2.122L7.878 10l-4.44-4.44a1.5 1.5 0 0 1 0-2.12Z" })));
});
